import { Classes, Colors, Tag } from "@blueprintjs/core";
import styled from "@emotion/styled";

import { BP_NS } from "@/css/constants";

const StyledTag = styled(Tag)`
  &.${Classes.TAG} {
    margin-top: 8px;
    margin-right: 8px;
    font-size: 16px;
    min-height: 38px;
    line-height: 1.2;
    background-color: #eef2f9;
    color: ${Colors.BLACK};
    padding: 0 16px;

    &.${BP_NS}-interactive:hover {
      background-color: ${Colors.LIGHT_GRAY3};
    }

    &.${Classes.LARGE} {
      font-size: 18px;
      padding: 0 16px;
      min-height: 48px;
    }
  }
`;

export default StyledTag;
